import { useQuery } from "@tanstack/react-query";
import { reviewsApi } from "../api/reviews.api";
import { accountKeys } from "../constants/query-keys";

export function useMyReviews(opts?: { enabled?: boolean }) {
  return useQuery({
    queryKey: accountKeys.reviews(),
    queryFn: reviewsApi.listMine,
    enabled: opts?.enabled,
  });
}
